"use strict";

var _classCallCheck = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEAR = exports.DECIMALS = void 0;

var bn_js_1 = __importDefault(require("bn.js"));

var bn_1 = require("./bn");

var utils_1 = require("./utils");
/**
 * Exponent for calculating how many indivisible units are there in one NEAR. See {@link NEAR_NOMINATION}.
 */


exports.DECIMALS = 24;

var NEAR = /*#__PURE__*/function (_bn_1$BNWrapper) {
  _inherits(NEAR, _bn_1$BNWrapper);

  var _super = _createSuper(NEAR);

  function NEAR() {
    _classCallCheck(this, NEAR);

    return _super.apply(this, arguments);
  }

  _createClass(NEAR, [{
    key: "toHuman",
    value:
    /**
     * Convert to string such as "1,000 N", "1 mN", or "1 nN"
     * @returns string showing NEAR amount in a human-readable way
     */
    function toHuman() {
      return (0, utils_1.toHuman)(this, 'N', exports.DECIMALS);
    }
  }, {
    key: "from",
    value: function from(bn) {
      return NEAR.from(bn);
    }
  }], [{
    key: "from",
    value:
    /**
     * Converts a BN, number, or string in yoctoNear to NEAR.
     *
     * @example
     * ```ts
     * const nearAmt  = NEAR.from(new BN("10000000"));
     * const nearAmt2 = NEAR.from("1");
     * ```
     */
    function from(bn) {
      if (bn instanceof bn_js_1.default) {
        var near = new NEAR(0); // @ts-expect-error internal method

        bn.copy(near); // eslint-disable-line @typescript-eslint/no-unsafe-call

        return near;
      }

      return new NEAR(bn);
    }
    /**
     * Convert human readable NEAR amount string to a NEAR object.
     *
     * @example
     * ```ts
     * NEAR.parse('1')     // => NEAR<'1000000000000000000000000'> (1e24 yoctoNEAR; 1 NEAR)
     * NEAR.parse('1,000') // => NEAR<'1000000000000000000000000000'> (1e27 yoctoNEAR; 1,000 NEAR)
     * NEAR.parse('1 mN')  // => NEAR<'1000000000000000000000'> (1e21 yoctoNEAR; 0.001 NEAR)
     * NEAR.parse('1 nN')  // => NEAR<'1000000000000000'> (1e15 yoctoNEAR; 0.000000001 NEAR)
     * ```
     *
     * @param x string representation of NEAR tokens amount
     * @returns new NEAR object wrapping the parsed amount
     */

  }, {
    key: "parse",
    value: function parse(x) {
      x = x.replace(utils_1.nearPattern, '').trim(); // Clean string for use with generic `parse`

      return new NEAR((0, utils_1.parse)(x, 24));
    }
  }]);

  return NEAR;
}(bn_1.BNWrapper);

exports.NEAR = NEAR;